<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-04 14:17:32
 * @Description: 地图板块接入
 * @FilePath: \sheyang\src\module\aMap\index.vue
-->
<template>
  <div class="amap-component">
    <slot name="amap-children"></slot>
    <div id="main" class="map"></div>
    <div class="position-btn" @click="resetMap">
      <img alt="" src="../../assets/images/position.png"/>
      <div>重新定位</div>
    </div>
    <div ref="infoWindow" class="info">
      <span class="close-text" @click="closeInfoWindow">
        <i class="el-icon-close"></i>
      </span>
      <map-station-card
        :visible="true"
        :showMore="showMore"
        :info="cardInfo"
        :cardName="cardName"
      />
    </div>
    <!-- <MapModal v-if="visible && modalData" @onCancel="onCancel" :modalData="modalData" /> -->
  </div>
</template>
<script>
import * as TYPE from '@/store/const';
import { getChargeStatus } from '@/api/stationStatistics/index';
import AMapLoader from '@amap/amap-jsapi-loader';
import {
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import mapICon from '@/assets/images/icon.png';
import mapStationCard from '@/module/mapStationCard/index.vue';

const adcodes = [100000];
const countryCode = 100000; // 全国
const DEFAULT_ZOOM = 13; // 初始zoom
const DEFAULT_CENTER = [120.28, 33.77]; // 初始地图中心
export default {
  name: 'AMap',
  components: {
    // MapModal,
    mapStationCard,
  },
  data() {
    return {
      visible: false,
      modalData: undefined,
      map: null,
      infoWindow: null, // 信息窗口实例
      markStations: [],
      showMore: false, // 是否显示更多
      cardInfo: {}, // 电站卡片信息
      cardName: 'overview', // 电站卡片名称
      currentStationInfo: {}, // 当前电站信息
    };
  },
  computed: {
    ...mapState({
      openStationDialog: (state) => state.global.openStationDialog,
      openPvDialog: (state) => state.global.openPvDialog,
      openEnergyStorageDialog: false, // 储能统计弹框
    }),
    ...mapGetters({
      stationList: 'stationList',
    }),
    ...mapGetters(
      'overView',
      [
        'overViewCardData',
        'chargingCardData',
        'pvCardData',
        'storageCardData',
      ],
    ),
    ...mapGetters(
      'batterySwap',
      [
        'statisticSiteData',
      ],
    ),
    cardVisible () {
      return Boolean(this.currentStationInfo.stationId);
    },
  },
  watch: {
    stationList(n, o) {
      // console.log('stationList', n);
      // 场站列表发生变化时进行更新
      this.getData();
    },
    $route: {
      handler (to, from) {
        if (to.path === '/') {
          this.cardName = 'overview';
          this.showMore = true;
        }
        if (to.path === '/chargingStats') {
          this.cardName = 'charging';
          this.showMore = true;
        }
        if (to.path === '/pvStats') {
          this.cardName = 'pv';
          this.showMore = false;
        }
        if (to.path === '/energyStorageStats') {
          this.cardName = 'storage';
          this.showMore = false;
        }
        // this.updateStationRender(true);
      },
      deep: true,
      immediate: true,
    },
    cardName: {
      handler (val) {
        // console.log('cardName', val);
      },
      deep: true,
    },
    currentStationInfo: {
      handler (newVal, oldVal) {
        // 如果属性存在且不相等
        if (newVal.stationId && (newVal.stationId !== oldVal.stationId)) {
          this.stubGroupQry(newVal.stationId);
          this.getStationId(newVal.stationId);
        }
        // this.cardInfo = this.currentStationInfo;
      },
      deep: true,
    },
  },
  created() {
    if (this.cardName === 'pv' || this.cardName === 'storage') {
      const params = {
        ids: '313744932.9415530,313744932.9415537,313744932.9415536,313744932.9415535,313744932.9419607',
      };
      this.getStationList(params);
    } else {
      this.getStationList();
    }

    this.mapInit();
  },
  methods: {
    ...mapMutations([
      TYPE.STATION_MODAL_CHANGE,
      TYPE.STATION_PV_MODAL_CHARGE,
      TYPE.STATION_ENERGY_STORAGE_CHARGE,
      'getStationId',
    ]),
    ...mapActions({
      getStationList: 'getStationList', // 获取电站列表
      getEnergyMap: 'getEnergyMap', // 获取电站能源地图
      stubGroupQry: 'overView/stubGroupQry', // 获取电桩分组列表
      getAllData: 'batterySwap/getAllData', // 获取电池交换统计数据
    }),
    onCancel() {
      this.visible = false;
      this.modalData = undefined;
    },
    resetMap() {
      if (!this.map) {
        return;
      }
      // console.log(this.map);
      this.map.setZoom(DEFAULT_ZOOM);
      this.map.setCenter(DEFAULT_CENTER);
      this.onCancel();
    },

    onChangeVisible (flag) {
      const { path } = this.$route;
      if (path === '/') {
        this.currentStationInfo = {};
        this.showMore = true;
        this.cardName = 'overview';
        this[TYPE.STATION_MODAL_CHANGE](flag);
      }
      // 充电统计弹框
      if (path === '/chargingStats') {
        this.currentStationInfo = {};
        this.showMore = true;
        this.cardName = 'charging';
        this[TYPE.STATION_MODAL_CHANGE](flag);
      }
      // 光伏统计弹框
      if (path === '/pvStats') {
        this.currentStationInfo = {};
        this[TYPE.STATION_PV_MODAL_CHARGE](flag);
      }
      // 储能弹框
      if (path === '/energyStorageStats') {
        this.currentStationInfo = {};
        this.showMore = false;
        this[TYPE.STATION_ENERGY_STORAGE_CHARGE](flag);
      }
    },
    getData() {
      this.markStations = this.stationList.map((item) => {
        return {
        ...item,
        value: [...item.coordinates],
        id: item.stationId,
        stationName: item.stationName,
        equipCnt: item.stubNum,
        address: item.address,
      }
      });
      this.mapInit();
    },
    // 初始化地图
    mapInit() {
      const that = this;
      AMapLoader.load({
        key: 'b291ad74e5bb531a1720f4eba94b124f', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Scale'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        AMapUI: {
          version: '1.1',
          plugins: ['geo/DistrictExplorer', 'overlay/SimpleInfoWindow'],
        },
      })
        .then((AMap) => {
          this.map = new AMap.Map('main', {
            // 设置地图容器id
            viewMode: '3D', // 是否为3D地图模式
            zoom: DEFAULT_ZOOM, // 初始化地图级别
            zooms: [8, 16],
            center: DEFAULT_CENTER, // 初始化地图中心点位置
            mapStyle: 'amap://styles/darkblue',
          });
          // const satellite = new AMap.TileLayer.Satellite({
          //   map: this.map,
          //   opacity: 1
          // });

          // 地图添加事件，点击地图空位 关闭 infoWindow
          this.map.on('click', (e) => {
            that.infoWindow.close();
          });
          // 绘制marks
          that.initMarks(AMap, this.map);

          // 限制地图显示范围
          // const bounds = this.map.getBounds();
          // this.map.setLimitBounds(bounds);
          function getAllRings(feature) {
            const coords = feature.geometry.coordinates;
            const rings = [];

            for (let i = 0, len = coords.length; i < len; i++) {
              rings.push(coords[i][0]);
            }

            return rings;
          }
          function initPage(DistrictExplorer) {
            // 创建一个实例
            const districtExplorer = new DistrictExplorer({
              map: that.map,
            });
            function renderAreaNode(areaNode) {
              // 绘制子区域
              districtExplorer.renderSubFeatures(areaNode, (feature, i) => ({
                cursor: 'default',
                bubble: true,
                strokeColor: '#3E70CA', // 线颜色
                strokeOpacity: 0, // 线透明度
                strokeWeight: 3, // 线宽
                fillColor: '#0B1D4B', // 填充色
                fillOpacity: 0.2, // 填充透明度
              }));

              // 绘制父区域
              districtExplorer.renderParentFeature(areaNode, {
                cursor: 'default',
                bubble: true,
                strokeColor: null, // 线颜色
                strokeOpacity: 0, // 线透明度
                strokeWeight: 5, // 线宽
                fillColor: '#0B1D4B', // 填充色
                fillOpacity: 0, // 填充透明度
              });
            }
            // 清除已有的绘制内容
            districtExplorer.clearFeaturePolygons();
            // 加载区域nodes
            districtExplorer.loadMultiAreaNodes(
              [countryCode].concat(adcodes),
              (error, areaNodes) => {
                const path = [];
                areaNodes.forEach((node) => {
                  // eslint-disable-next-line prefer-spread
                  path.push.apply(path, getAllRings(node.getParentFeature()));
                });
                // eslint-disable-next-line no-new
                new AMap.Polygon({
                  bubble: true,
                  lineJoin: 'round',
                  strokeColor: '#3E70CA', // 线颜色
                  strokeOpacity: 1, // 线透明度
                  strokeWeight: 5, // 线宽
                  fillColor: '#0B1D4B', // 填充色
                  fillOpacity: 0.4, // 填充透明度
                  map: that.map,
                  path,
                });

                // eslint-disable-next-line no-shadow
                districtExplorer.loadMultiAreaNodes(adcodes, (error, areaNodes) => {
                  for (let i = 0, len = areaNodes.length; i < len; i++) {
                    renderAreaNode(areaNodes[i]);
                  }
                });
              },
            );
          }
          window.AMapUI.loadUI(['geo/DistrictExplorer'], (DistrictExplorer) => {
            initPage(DistrictExplorer);
            const canvas = document.getElementsByClassName('amap-layer')[0];
            // console.log(canvas);
            // const ctx = canvas.getContext('2d');
            // console.log(ctx);
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 初始化场站marks
    initMarks(AMap, map) {
      // 生成蓝,绿,黄三色图标
      const icons = [
        new AMap.Icon({
          size: new AMap.Size(60, 79), // 图标尺寸
          image: mapICon, // Icon的图像
          imageSize: new AMap.Size(60, 79), // 根据所设置的大小拉伸或压缩图片
        }),
      ];
      // console.log('--坐标点数据', this.markStations);

      // 地图自定义窗体 使用自定义组件 mapStationCard
      this.infoWindow = new AMap.InfoWindow({
        isCustom: true,
        content: this.$refs.infoWindow,
        offset: new AMap.Pixel(0, -50),
      });

      const marks = this.markStations.map((station) => {
        const type = 0;
        const lnglat = station.value;
        const mark = new AMap.Marker({
          ...station,
          position: new AMap.LngLat(lnglat[0], lnglat[1]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          offset: new AMap.Pixel(-29, -51), // 设置点标记偏移量
          title: station.stationName,
          icon: icons[type],
        });
        // 点击打开modal
        mark.on('click', (e) => {
          // eslint-disable-next-line no-underscore-dangle
          const { id } = e.target._opts;
          const data = this.markStations.find((item) => item.id === id);

          const { stationName } = data;
          getChargeStatus({stubGroupId:id}).then(res=>{
            let {data}=res
            let {adcChargingRatio,adcFaultRatio}=data
            this.cardInfo = {
              stationStubStatus:adcFaultRatio === 1? 0:1,
              plugFaultRate:adcFaultRatio,
              stationId:id,
              plugUseRate:adcChargingRatio,
              stubGroupName: stationName,
            };
          })
          // 传入当前点击的marker 的位置 作为窗体的位置
          this.infoWindow.open(map, e.target.getPosition());
        });
        return mark;
      });
      map.add(marks);
    },
    // 高德地图，关闭 infoWindow
    closeInfoWindow() {
      this.infoWindow.close();
    },
  },
};
</script>

<style scoped>
.amap-component {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
}

.info {
  position: relative;
}

.close-text {
  position: absolute;
  right:10px;
  top: 14px;
  color: #fff;
  z-index: 1;
  cursor: pointer;
}

.position-btn {
  position: absolute;
  right: 120px;
  bottom: 46px;
  text-align: center;
  cursor: pointer;
}
.position-btn>div {
  font-size: 14px;
  font-weight: 500;
  color: #B3D6F9;
  line-height: 20px;
}
.position-btn>img {
  width: 36px;
  height: 36px;
}
.map {
  opacity: 0.6;
  width: 100%;
  height: 100%;
}
</style>
